module.exports = __webpack_public_path__ + "img/sindirepa.876692fd.png";